import { render, staticRenderFns } from "./mtjdOrderConfirm.vue?vue&type=template&id=0c4ed687&scoped=true&"
import script from "./mtjdOrderConfirm.vue?vue&type=script&lang=js&"
export * from "./mtjdOrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./mtjdOrderConfirm.vue?vue&type=style&index=0&id=0c4ed687&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ed687",
  null
  
)

export default component.exports